import { newE2EPage } from '@stencil/core/testing';

describe('zero-account', () => {
  it('renders', async () => {
    const page = await newE2EPage();

    await page.setContent('<zero-account></zero-account>');
    const element = await page.find('zero-account');
    expect(element).toHaveClass('hydrated');
  });

  it('renders changes to the name data', async () => {
    const page = await newE2EPage();

    await page.setContent('<zero-account></zero-account>');
    const component = await page.find('zero-account');
    const element = await page.find('zero-account >>> div');
    expect(element.textContent).toEqual(`Hello, World! I'm `);

    component.setProperty('first', 'James');
    await page.waitForChanges();
    expect(element.textContent).toEqual(`Hello, World! I'm James`);

    component.setProperty('last', 'Quincy');
    await page.waitForChanges();
    expect(element.textContent).toEqual(`Hello, World! I'm James Quincy`);

    component.setProperty('middle', 'Earl');
    await page.waitForChanges();
    expect(element.textContent).toEqual(`Hello, World! I'm James Earl Quincy`);
  });
});
